import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const getFlag = (countryCode) => {
  if (!countryCode) return ''
  const offset = 127397
  const codePoints = [...countryCode.toUpperCase()].map(char =>{
    return char.charCodeAt(0) + offset
  })
  return String.fromCodePoint(...codePoints)
}

const LanguageToken = ({ countryCode, text }) => (
  < div className="token">
    { getFlag(countryCode) } <T text={ text } />
  </div>
  
)

LanguageToken.propTypes = {
  countryCode: PropTypes.object,
  text: PropTypes.string
}

export default LanguageToken